import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/modules/shared/ui/components/tooltip"
import { Avatar, AvatarFallback } from "@/modules/shared/ui/components/avatar"
import { ResourceAssigneeDto } from "../../dtos/ResourceAccessDtos"

function initials(name: string) {
  const parts = name.trim().split(/\s+/)
  const chars = parts.length > 1 ? [parts[0][0], parts[parts.length - 1][0]] : [parts[0]?.[0] ?? "?"]
  return chars.join("").toUpperCase()
}

interface AssigneeStackProps {
  assignees: ResourceAssigneeDto[]
  max?: number
}

/** A record with no assignees is org-wide, not "assigned to nobody" — render nothing for that case. */
export function AssigneeStack({ assignees, max = 3 }: AssigneeStackProps) {
  if (assignees.length === 0) return null

  const shown = assignees.slice(0, max)
  const overflow = assignees.length - shown.length

  return (
    <TooltipProvider>
      <div className="flex items-center -space-x-2">
        {shown.map((a) => (
          <Tooltip key={a.userId}>
            <TooltipTrigger asChild>
              <Avatar className="size-6 border-2 border-background">
                <AvatarFallback className="text-[10px]">{initials(a.userName)}</AvatarFallback>
              </Avatar>
            </TooltipTrigger>
            <TooltipContent>
              {a.userName} — {a.level}
            </TooltipContent>
          </Tooltip>
        ))}
        {overflow > 0 && (
          <Avatar className="size-6 border-2 border-background">
            <AvatarFallback className="text-[10px]">+{overflow}</AvatarFallback>
          </Avatar>
        )}
      </div>
    </TooltipProvider>
  )
}
